import { useMemo } from 'react';
import { Letter, Quality as ImageQuality } from '@abhisek507/html2multipagepdf/constants';
import { PRODUCT_INFO, Eversesnse, Axena, NO_CMN_UI, Dexcom, Apretude, Vyepti, PATIENT } from '../constants/patientChart.constant';
import EversenseUI, { CMNEversenseTemplateIdentifier } from '../components/cmnTemplate/Eversense';
import AxenaUI, { CMNAxenaTemplateIdentifier } from '../components/cmnTemplate/Axena';
import DexcomUI, { CMNDexcomTemplateIdentifier } from '../components/cmnTemplate/Dexcom';
import ApretudeUI, { CMNApretudeTemplateIdentifier } from '../components/cmnTemplate/Apretude';
import VyeptiUI, { CMNVyeptiTemplateIdentifier } from '../components/cmnTemplate/Vyepti';
import { ITEMPLATE } from '../constants/cmnTemplateForEversense.constant';
import { FEATURE } from '../utils/feature';
import { ENV } from '../utils/env';
import { preparePDF } from '../utils/referralForm';

const hasFeature = FEATURE();
const env = ENV();

const CMNUICollection = new Map([
  [Eversesnse, ITEMPLATE({
    Template: EversenseUI,
    id: CMNEversenseTemplateIdentifier,
    fileName: CMNEversenseTemplateIdentifier,
    preparePDF,
    enabled: true,
    requiredFields: [],
    hasPIDDependency: true,
    pageOptions: Letter,
    imageQuality: ImageQuality[env.CMN_PDF_QUALITY],
  })],
  [Axena, ITEMPLATE({
    Template: AxenaUI,
    id: CMNAxenaTemplateIdentifier,
    fileName: CMNAxenaTemplateIdentifier,
    preparePDF,
    enabled: hasFeature.SHOW_CMN_FOR_AXENA,
    requiredFields: [],
    hasPIDDependency: false,
    pageOptions: Letter,
    imageQuality: ImageQuality[env.CMN_PDF_QUALITY],
  })],
  [Dexcom, ITEMPLATE({
    Template: DexcomUI,
    id: CMNDexcomTemplateIdentifier,
    fileName: CMNDexcomTemplateIdentifier,
    preparePDF,
    enabled: hasFeature.SHOW_CMN_FOR_DEXCOM,
    requiredFields: [],
    hasPIDDependency: true,
    pageOptions: Letter,
    imageQuality: ImageQuality[env.CMN_PDF_QUALITY],
  })],
  [Apretude, ITEMPLATE({
    Template: ApretudeUI,
    id: CMNApretudeTemplateIdentifier,
    fileName: CMNApretudeTemplateIdentifier,
    preparePDF,
    enabled: hasFeature.SHOW_CMN_FOR_APRETUDE,
    requiredFields: [],
    hasPIDDependency: true,
    pageOptions: Letter,
    imageQuality: ImageQuality[env.CMN_PDF_QUALITY],
  })],
  [Vyepti, ITEMPLATE({
    Template: VyeptiUI,
    id: CMNVyeptiTemplateIdentifier,
    fileName: CMNVyeptiTemplateIdentifier,
    preparePDF,
    enabled: hasFeature.SHOW_CMN_FOR_VYEPTI,
    requiredFields: [],
    hasPIDDependency: true,
    pageOptions: Letter,
    imageQuality: ImageQuality[env.CMN_PDF_QUALITY],
  })],
]);

export const useCmnTemplate = ({
  product = PRODUCT_INFO(),
  patient = PATIENT(),
}) => {
  return useMemo(() => {
    if (!patient.api.called) {
      return NO_CMN_UI();
    }

    if (patient.api.loading) {
      return NO_CMN_UI();
    }

    if (!patient.UserId) {
      return NO_CMN_UI();
    }

    if (!product.pdfInfo.template) {
      return NO_CMN_UI();
    }

    if (!CMNUICollection.has(product.pdfInfo.template)) {
      return NO_CMN_UI();
    }

    const UI = CMNUICollection.get(product.pdfInfo.template);
    if (!UI.enabled) {
      return NO_CMN_UI();
    }

    if (UI.hasPIDDependency && !product.pdfInfo.productId) {
      return NO_CMN_UI();
    }

    return { template: product.pdfInfo.template, ...UI };
  }, [product]);
};

export default useCmnTemplate;
